<!-- views/doc/index.vue -->
<template>
  <div>
    <br>
    <div style="background:white;  box-sizing: border-box;">
      <el-tabs stretch v-model="activeName" >
        <el-tab-pane label="我要记账" name="1">
          <iframe :src="jizhangUrl"></iframe>
        </el-tab-pane>
       <!-- <el-tab-pane label="我要记账2" name="7">
          <iframe src="https://jijiane-cn.feishu.cn/share/base/form/shrcnDMAnja7VEQ0iwi7OJ88Pdb"></iframe>
        </el-tab-pane>-->

       <!-- <el-tab-pane label="日仪表盘" name="2">
          <iframe :src="dayUrl"></iframe>
        </el-tab-pane>-->
        <el-tab-pane label="月仪表盘" name="3">
          <iframe :src="monthUrl"></iframe>
        </el-tab-pane>
        <el-tab-pane label="年仪表盘" name="4">
          <iframe :src="yearUrl"></iframe>
        </el-tab-pane>
        <el-tab-pane label="记账查询" name="5">
          <iframe :src="queryUrl"></iframe>
        </el-tab-pane>
      </el-tabs>
    </div>
    <br>
  </div>
</template>
<script>

export default {
  name: "JiZhangPage",
  data() {
    return {
      jizhangUrl: 'https://jijiane-cn.feishu.cn/share/base/form/shrcnemk1cnlgxEQkKDHFWLrGnd?prefill_%E8%AE%B0%E8%B4%A6%E5%9C%BA%E6%99%AF=-%E5%90%83%E9%A5%AD%2F%E4%B9%B0%E8%8F%9C%2F%E9%9B%B6%E9%A3%9F',
      dayUrl: 'https://jijiane-cn.feishu.cn/share/base/dashboard/shrcnsG8jPvh4ysQOZmUndrLLMb',
      monthUrl: 'https://jijiane-cn.feishu.cn/share/base/dashboard/shrcnjqjfCoiiHGiiTmODie2tkg',
      yearUrl: 'https://jijiane-cn.feishu.cn/share/base/dashboard/shrcnmAKmCoXkSgVBZOjZs3kj0c',
      queryUrl: 'https://jijiane-cn.feishu.cn/share/base/query/shrcnRZeguNpUluZcISIKpvOqS9',
      title: 'JiJianE.cn·极简E记账',// 标题
      activeName: '1'
    };
  },
  methods: {
    updateTitle() {
      document.title = this.title
    },
  },
  mounted() {
    this.updateTitle();
  },
};
</script>
<style scoped>
iframe {
  width: 100%;
  height: auto; /* 自动高度 */
  min-height: 300vh; /* 最小高度，视具体情况而定 */
  border: 0;
  scrolling: no;
  overflow: hidden;
  display: block;
}

@media (max-width: 768px) {
  iframe {
    min-height:108vh; /* 移动设备上的最小高度 */
   /* min-height:145vh; *//* 移动设备上的最小高度 */
  }
}
</style>
